import { useMemo } from 'react';

export default function Snow({ intensity = 'med' }: { intensity?: string }) {
  const count = useMemo(() => (intensity === 'high' ? 140 : intensity === 'low' ? 50 : 90), [intensity]);

  const flakes = useMemo(
    () =>
      new Array(count).fill(0).map((_, i) => {
        const size = 2 + Math.random() * 3; // px
        const left = Math.random() * 100;   // vw %
        const dur = 10 + Math.random() * 12; // s
        const delay = Math.random() * 8;    // s
        const drift = (Math.random() * 60 - 30) + 'px';
        const spin = (180 + Math.random() * 360) + 'deg';

        return (
          <svg
            key={i}
            className="snowflake overlay-svg"
            viewBox="0 0 10 10"
            style={{
              left: `${left}%`,
              animationDuration: `${dur}s, ${Math.max(5, dur - 4)}s, ${dur}s`,
              animationDelay: `${delay}s, ${delay}s, ${delay}s`,
              width: size * 3,
              height: size * 3,
              ['--drift' as string]: drift,
              ['--spin' as string]: spin,
            }}
          >
            <g fill="none" stroke="rgba(255,255,255,.9)" strokeWidth="0.8" strokeLinecap="round">
              <line x1="5" y1="0" x2="5" y2="10" />
              <line x1="0" y1="5" x2="10" y2="5" />
              <line x1="1.5" y1="1.5" x2="8.5" y2="8.5" />
              <line x1="1.5" y1="8.5" x2="8.5" y2="1.5" />
            </g>
          </svg>
        );
      }),
    [count]
  );

  return <div className="overlay-root">{flakes}</div>;
}
